import { PlaceholderPage } from "@/components/placeholder/PlaceholderPage";
import { TrendingDown } from "lucide-react";
import { MainLayout } from "@/components/MainLayout";

export default function ArchitectsEngineersAddExpensePage() {
  return (
<MainLayout>
    <PlaceholderPage
      title="Lançar Custo no Projeto"
      description="Registre custos e despesas em seus projetos."
      icon={TrendingDown}
    />
  
    </MainLayout>);
}

